var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8965 1.89624H6.89648C4.12648 1.89624 1.89648 4.12624 1.89648 6.89624V16.8962C1.89648 19.6562 4.13648 21.8962 6.89648 21.8962H16.8965C19.6565 21.8962 21.8965 19.6562 21.8965 16.8962V6.89624C21.8965 4.13624 19.6565 1.89624 16.8965 1.89624ZM6.89648 5.89624C7.44648 5.89624 7.89648 6.34624 7.89648 6.89624C7.89648 7.44624 7.44648 7.89624 6.89648 7.89624C6.34648 7.89624 5.89648 7.44624 5.89648 6.89624C5.89648 6.34624 6.34648 5.89624 6.89648 5.89624ZM19.8965 16.8962C19.8965 18.5462 18.5465 19.8962 16.8965 19.8962H6.89648C5.24648 19.8962 3.89648 18.5462 3.89648 16.8962V16.3762L7.37648 13.5862C7.71648 13.3162 8.19648 13.2962 8.55648 13.5362L9.12648 13.9262C10.2165 14.6362 11.6465 14.5762 12.6665 13.7662L15.1165 11.7962C15.5165 11.4762 16.0965 11.5062 16.4565 11.8762L19.8965 15.3062V16.8962Z",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgol);
export default __webpack_public_path__ + "static/media/bgol.7117e0466c741976f4ce238aa2c413aa.svg";
export { ForwardRef as ReactComponent };